import { render } from "./Search.vue?vue&type=template&id=2646f90c&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "@/assets/css/components/header_basic.css?vue&type=style&index=0&id=2646f90c&scoped=true&lang=css"
import "@/assets/css/components/header_custom_01.css?vue&type=style&index=1&id=2646f90c&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\sonagimall.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2646f90c"]])

export default __exports__